@let isMobile = breakpoints() === "mobile";
@let _requestType = requestType();
<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-7 col-xs-12">
        <app-title [titles]="[title()]" class="title" />
        <p class="sub-title">Tous les champs sont obligatoires</p>
      </div>
      <div class="col-lg-12 col-xs-12 content">
        <div class="form">
          <div class="step step-one">
            <div class="form-item">
              Heureux d'échanger avec vous
              <div class="form-item-input">
                <app-form-item
                  (value)="updateForm($event)"
                  [customStyle]="{ width: isMobile ? '18.5rem' : '36rem' }"
                  [debounceTime]="1000"
                  [specs]="specs()[0]!"
                  [theme]="'DASHED'" />
                <span class="dot">.</span>
              </div>
            </div>
            <div class="form-item">
              Votre demande concerne
              <div class="form-item-input">
                <app-form-item
                  (value)="updateForm($event)"
                  [customStyle]="{ width: isMobile ? '25.5rem' : '50rem' }"
                  [isMobile]="isMobile"
                  [specs]="specs()[1]!"
                  [theme]="'DASHED'" />
                @if (!isMobile) {
                  <span class="dot">.</span>
                }
              </div>
            </div>
          </div>
          @if (isStepVisible(["fullName", "requestType"]) && shouldShowStore()) {
            <div @fadeInOut class="step step-two">
              <div class="form-item">
                Sélectionnez votre magasin
                <div
                  [class.form-item-input--dashed-selected]="!!form['store']"
                  class="form-item-input form-item-input--dashed">
                  <span (click)="openStoreDialog(storeDialog)" class="modal-input">{{
                    storeSelected() ? storeSelected() : "saisissez les premiers caractères"
                  }}</span>
                </div>
              </div>
              @if (shouldShowSavFields()) {
                <div class="form-item">
                  et votre code postal :
                  <div class="form-item-input">
                    <app-form-item
                      (value)="updateForm($event)"
                      [customStyle]="{ width: isMobile ? '17rem' : '33rem' }"
                      [debounceTime]="1000"
                      [specs]="specs()[3]!"
                      [theme]="'DASHED'" />
                    <span class="dot">.</span>
                  </div>
                </div>
              }
            </div>
          }
          @if (isStepVisible(["fullName", "requestType", "store", "postalCode"]) && shouldShowSavFields()) {
            <div @fadeInOut class="step step-three">
              <div class="form-item">
                L'objet de votre demande de SAV concerne
                <div class="form-item-input">
                  <app-form-item
                    (value)="updateForm($event)"
                    [customStyle]="{ width: isMobile ? '22rem' : '43rem' }"
                    [isMobile]="isMobile"
                    [specs]="specs()[2]!"
                    [theme]="'DASHED'" />
                  @if (!isMobile) {
                    <span class="dot">.</span>
                  }
                </div>
              </div>
            </div>
          }
          @if (
            isStepVisible(["fullName", "requestType", "store", "postalCode", "savCategory"]) && shouldShowSavFields()
          ) {
            <div @fadeInOut class="step step-four-sav">
              <div class="form-item-textarea">
                Dites-nous tout :
                <div class="form-item-textarea-input">
                  <app-form-item
                    (value)="updateForm($event)"
                    [customStyle]="{
                      'max-width': isMobile ? 'auto' : '115rem',
                      color: 'rgb(255 255 255 / 60%)',
                      'font-size': isMobile ? '1.6rem' : '3.2rem',
                      'line-height': isMobile ? '2.4rem' : '4rem',
                    }"
                    [debounceTime]="1000"
                    [specs]="specs()[4]!"
                    [theme]="'FILL'" />
                </div>
              </div>
            </div>
          }
          @if (isStepVisible(["fullName", "requestType", "store"]) && _requestType === "COMMANDE") {
            <div @fadeInOut class="step step-two-commande">
              <div class="form-item-textarea">
                Saisissez votre demande
                <div class="form-item-textarea-input">
                  <app-form-item
                    (value)="updateForm($event)"
                    [customStyle]="{
                      'max-width': isMobile ? 'auto' : '81rem',
                      color: 'rgb(255 255 255 / 60%)',
                      'font-size': isMobile ? '1.6rem' : '3.2rem',
                      'line-height': isMobile ? '2.4rem' : '4rem',
                    }"
                    [debounceTime]="1000"
                    [specs]="specs()[4]!"
                    [theme]="'FILL'" />
                </div>
              </div>
            </div>
          }
          @if (isStepVisible(["fullName", "requestType"]) && _requestType === "RENSEIGNEMENT") {
            <div @fadeInOut class="step step-two-renseignement">
              <div class="form-item-textarea">
                Saisissez votre demande
                <div class="form-item-textarea-input">
                  <app-form-item
                    (value)="updateForm($event)"
                    [customStyle]="{
                      'max-width': isMobile ? 'auto' : '81rem',
                      color: 'rgb(255 255 255 / 60%)',
                      'font-size': isMobile ? '1.6rem' : '3.2rem',
                      'line-height': isMobile ? '2.4rem' : '4rem',
                    }"
                    [debounceTime]="1000"
                    [specs]="specs()[4]!"
                    [theme]="'FILL'" />
                </div>
              </div>
            </div>
          }
          @if (
            (_requestType === "COMMANDE" && isStepVisible(["fullName", "requestType", "store", "message"])) ||
            (_requestType === "SAV" &&
              isStepVisible(["fullName", "requestType", "store", "postalCode", "savCategory", "message"])) ||
            (_requestType === "RENSEIGNEMENT" && isStepVisible(["fullName", "requestType", "message"]))
          ) {
            <div @fadeInOut class="step step-four">
              @if (isMobile) {
                <div class="form-item">
                  Nous pouvons vous joindre
                  <div>
                    <span>au </span>
                    <div class="form-item-input">
                      <app-form-item
                        (value)="updateForm($event)"
                        [customStyle]="{ width: '24rem' }"
                        [debounceTime]="1000"
                        [specs]="specs()[5]!"
                        [theme]="'DASHED'" />
                      <span class="dot">.</span>
                    </div>
                  </div>
                  <div>
                    <span>Et à l'adresse </span>
                    <div class="form-item-input">
                      <app-form-item
                        (value)="updateForm($event)"
                        [customStyle]="{ width: '19rem' }"
                        [debounceTime]="1000"
                        [specs]="specs()[6]!"
                        [theme]="'DASHED'" />
                      <span class="dot">.</span>
                    </div>
                  </div>
                </div>
              } @else {
                <div class="form-item">
                  Nous pouvons vous joindre au
                  <div class="form-item-input">
                    <app-form-item
                      (value)="updateForm($event)"
                      [customStyle]="{ width: '47rem' }"
                      [debounceTime]="1000"
                      [specs]="specs()[5]!"
                      [theme]="'DASHED'" />
                    <span class="dot">.</span>
                  </div>
                </div>
                <div class="form-item">
                  <span>Et à l'adresse </span>
                  <div class="form-item-input">
                    <app-form-item
                      (value)="updateForm($event)"
                      [customStyle]="{ width: '36.5rem' }"
                      [debounceTime]="1000"
                      [specs]="specs()[6]!"
                      [theme]="'DASHED'" />
                    <span class="dot">.</span>
                  </div>
                </div>
              }
              @if (_requestType === "RENSEIGNEMENT") {
                <app-form-item (value)="updateForm($event)" [specs]="specs()[7]!" [theme]="'FILL'" />
              }
            </div>
          }
          @if (
            (_requestType === "COMMANDE" &&
              isStepVisible(["fullName", "requestType", "store", "message", "phone", "email"])) ||
            (_requestType === "SAV" &&
              isStepVisible([
                "fullName",
                "requestType",
                "store",
                "postalCode",
                "savCategory",
                "message",
                "phone",
                "email",
              ])) ||
            (_requestType === "RENSEIGNEMENT" &&
              isStepVisible(["fullName", "requestType", "message", "phone", "email"]))
          ) {
            <div @fadeInOut class="step step-five">
              <app-button
                (buttonClicked)="onSubmit()"
                [icon]="{ name: 'CHEVRON_RIGHT' }"
                [isLoading]="isSending()"
                [label]="'Envoyer votre message'" />
              <div role="alert">
                @if (isSendFailed()) {
                  <div class="error error-dashed">
                    Votre demande n'a pas pu être envoyée. Réessayez ou contactez votre boutique.
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</section>
<dialog #storeDialog class="dialog dialog-location">
  <button (click)="closeStoreDialog(storeDialog)" class="dialog-close">Annuler</button>
  <div class="dialog-content">
    <div class="dialog-location-find">Choisissez votre boutique</div>
    <app-search
      (resetClick)="onReset()"
      (valueInput)="onStoreNameInput($event)"
      [placeholder]="'Saisir le nom de votre boutique'" />
    @if (isDisplay().storeLoading) {
      <div class="loading">
        <div class="spinner spinner--white"></div>
      </div>
    }
    @if (isDisplay().storeResults) {
      <div class="dialog-location-suggestion">
        <app-dropdown
          (selected)="onStoreSelected($event); closeStoreDialog(storeDialog)"
          [isOpen]="true"
          [isScroll]="true"
          [items]="storeSuggestions()" />
      </div>
    }
    @if (isDisplay().storeNotFound) {
      <div class="dialog-location-no-results">
        @if (_requestType !== "RENSEIGNEMENT") {
          <p class="text">
            Vous ne retrouvez pas votre boutique ? Contactez directement notre service client à l'adresse
            <a href="mailto:serviceclients@perene.com">serviceclients&#64;perene.com</a>
            @if (_requestType === "SAV") {
              ou au <a href="tel:+33450330300">04 50 33 03 00</a> (prix d'un appel local)
            }
          </p>
        } @else {
          <p class="text">Aucune boutique trouvée.</p>
        }
      </div>
    }
  </div>
</dialog>
